export enum PatientTeleexpertiseStep {
  INFORMATIONS = 0,
  REPORT = 1,
  RESULT = 2,
}
